// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_gW","advertDetailContactGroup__header":"c-l_gX","advertDetailContactGroup__value":"c-l_gY"};